// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getCronReportRequest: ['data'],
  getCronReportSuccess: ['data'],
  getCronReportFailure: ['err'],

  getCronReportItemRequest: ['data'],
  getCronReportItemSuccess: ['data'],
  getCronReportItemFailure: ['err'],

  disableAttractionRequest: ['data'],
  disableAttractionSuccess: ['data'],
  disableAttractionFailure: ['err'],

  enableAttractionRequest: ['data'],
  enableAttractionSuccess: ['data'],
  enableAttractionFailure: ['err'],

  getWhitelistRequest: ['data'],
  getWhitelistSuccess: ['data'],
  getWhitelistFailure: ['err'],

  putWhitelistRequest: ['data'],
  putWhitelistSuccess: ['data'],
  putWhitelistFailure: ['err'],

  deleteWhitelistRequest: ['data'],
  deleteWhitelistSuccess: ['data'],
  deleteWhitelistFailure: ['err']
})

export const CronReportTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  data_item: {},
  data_whitelist: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
export const request = (state: Object) =>
  state.merge({ fetching: true, err: null })

export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null,
    success: true
  })

export const successItem = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data_item: data,
    err: null,
    success: true
  })

export const successWhitelist = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data_whitelist: data,
    err: null,
    success: true
  })

export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_CRON_REPORT_SUCCESS]: success,
  [Types.GET_CRON_REPORT_REQUEST]: request,
  [Types.GET_CRON_REPORT_FAILURE]: failure,

  [Types.GET_CRON_REPORT_ITEM_SUCCESS]: successItem,
  [Types.GET_CRON_REPORT_ITEM_REQUEST]: request,
  [Types.GET_CRON_REPORT_ITEM_FAILURE]: failure,

  [Types.DISABLE_ATTRACTION_SUCCESS]: manipulateSuccess,
  [Types.DISABLE_ATTRACTION_REQUEST]: manipulateRequest,
  [Types.DISABLE_ATTRACTION_FAILURE]: manipulateFailure,

  [Types.ENABLE_ATTRACTION_SUCCESS]: manipulateSuccess,
  [Types.ENABLE_ATTRACTION_REQUEST]: manipulateRequest,
  [Types.ENABLE_ATTRACTION_FAILURE]: manipulateFailure,

  [Types.GET_WHITELIST_SUCCESS]: successWhitelist,
  [Types.GET_WHITELIST_REQUEST]: request,
  [Types.GET_WHITELIST_FAILURE]: failure,

  [Types.PUT_WHITELIST_SUCCESS]: manipulateSuccess,
  [Types.PUT_WHITELIST_REQUEST]: manipulateRequest,
  [Types.PUT_WHITELIST_FAILURE]: manipulateFailure,

  [Types.DELETE_WHITELIST_SUCCESS]: manipulateSuccess,
  [Types.DELETE_WHITELIST_REQUEST]: manipulateRequest,
  [Types.DELETE_WHITELIST_FAILURE]: manipulateFailure
})



// WEBPACK FOOTER //
// ./src/Redux/CronReportRedux.js